import { render, staticRenderFns } from "./CompareEdit.vue?vue&type=template&id=073daf5b&scoped=true&"
import script from "./CompareEdit.vue?vue&type=script&lang=js&"
export * from "./CompareEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompareEdit.vue?vue&type=style&index=0&id=073daf5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073daf5b",
  null
  
)

export default component.exports